
/* eslint-disable */
import React, { Component } from "react";
import { Route, Switch } from "react-router";
import { withRouter } from "react-router-dom";
import { Header, Footer, MobileHeader } from "../../components";
import { Home, Article, MobileNews, Christmas2025 } from "../../screens";
import { MobileBlog } from "../MobileBlog";

class Routes extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/2025" component={Christmas2025} />
        <Route>
          <div className="dashboard-wrap">
            <div className="only-desktop">
              <Header />
            </div>
            <div className="only-mobile">
              <MobileHeader />
            </div>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/news" component={MobileNews} />
              <Route path="/article" component={Article} />
            </Switch>
            <div className="only-desktop">
              <Footer />
            </div>
            <div className="only-mobile">
              <MobileBlog />
            </div>
          </div>
        </Route>
      </Switch>
    );
  }
}

export default withRouter(Routes);
